import React, { useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from '../navbar/Navbar';
import "./Web.css";
import Formpage from '../Formpage/Formpage';
const items = [
    {
        title: 'BASIC WEBSITE',
        description: [
            'Up to 5 Web Pages',
            'Modern & Responsive Design',
            '1 Month Free Support',
            'WhatsApp Chat Integration',
            'Google Maps Embedding',
            'Contact Form Integration',
            '3 E-Mail business id',
        ],
    },
    {
        title: 'STANDARD WEBSITE',
        description: [
            'Up to 12 Custom Pages',
            'Modern & Responsive Design',
            'Interactive Contact Form',
            'WhatsApp Chat Button & Integration',
            'Social Media Integration',
            'Google Maps Integration',
            'Free Support for 3 Months',
            '5 Mail IDs for Business',
        ],
    },
    {
        title: 'ADVANCED WEBSITE',
        description: [
            'Up to 12+ Custom Pages',
            'Premium, Mobile-Responsive Design',
            'Custom Animations & UI Enhancements',
            'Advanced Contact Forms with Filters',
            'WhatsApp Chat + Live Chat Integration',
            'Google Maps & Location Features',
            'Social Media Feeds & Share Buttons',
            'Domain & Hosting',
            '6 Month Free Support',
        ],
    },
    {
        title: 'CMS BASED WEBSITE',
        description: [
            'Fully Custom CMS Website',
            'Up to 20 Pages with Dynamic Content',
            'Premium, Mobile-Responsive Design',
            'Custom Animations & UI Enhancements',
            'Advanced Forms & Integrations',
            'WhatsApp Chat, Live Chat & Google Maps',
            'Social Media Feeds & Share Buttons',
            'Hosting & Domain Setup',
            'E-commerce Module',
            'API & Third-Party Integrations',
            '6 Month Free Support',
        ],
    },
];

function Web() {
      const [show, setShow] = useState(false);
      const handleShow = () => setShow(true);
      const handleClose = () => setShow(false);
   const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: '0px',
    arrows: true,
    initialSlide: 0, // BASIC will be on left, STANDARD will be center
};


    return (
        <>
            <Navbar />
            <div className="container-fluid web-container" >


                <div className="wrapper">
                    <section>
                        <div class="service-heading">
                            <h2>WEB DEVELOPMENT</h2>
                            <div class="triangle-container">
                                <span class="triangle left"></span>
                                <span class="triangle right"></span>
                            </div>
                        </div>
                        {/* <center><h2 style={{ marginTop: "50px", color: "black" }}>Web Development</h2></center> */}
                    </section>

                    <Slider {...settings} className="news-slider">
                        {items.map((item, index) => (
                            <div className="news-slider__item" key={index}>
                                <div className="news__item">
                                    <div className="news__title">{item.title}</div>
                                    <ul className="news__txt">
                                        {item.description.map((point, idx) => (
                                            <li key={idx}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </Slider>

                </div>
            </div>
            <div
                    className="container d-flex justify-content-center my-4"
                    data-aos="fade-up"
                    data-aos-delay="1000"
                >
                    <button className="btn-15" onClick={handleShow}>
                        Get Enquiry
                    </button>
                </div>

      <Formpage show={show} onClose={handleClose} />
        </>
    );
}

export default Web;
